import { createAction } from "redux-actions";

export const LOGIN = "LOGIN";
export const login = createAction(LOGIN);

export const LOGOUT = "LOGOUT";
export const logout = createAction(LOGOUT);

export const USER_LIST = "USER_LIST";
export const userList = createAction(USER_LIST);

export const CREATE_USER = "CREATE_USER";
export const createUser = createAction(CREATE_USER);

export const DETAIL_USER = "DETAIL_USER";
export const detailUser = createAction(DETAIL_USER);

export const UPDATE_USER = "UPDATE_USER";
export const updateUser = createAction(UPDATE_USER);

export const DELETE_USER = "DELETE_USER";
export const deleteUser = createAction(DELETE_USER);

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const changePassword = createAction(CHANGE_PASSWORD);

export const CHANGE_PASSWORD_BY_ADMIN = "CHANGE_PASSWORD_BY_ADMIN";
export const changePasswordByAdmin = createAction(CHANGE_PASSWORD_BY_ADMIN);

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const forgotPassword = createAction(FORGOT_PASSWORD);

export const RESET_PASSWORD = "RESET_PASSWORD";
export const resetPassword = createAction(RESET_PASSWORD);

export const VERIFYEMAIL = "VERIFYEMAIL";
export const verifyEmail = createAction(VERIFYEMAIL);

export const RESEND_VERIFICATION = "RESEND_VERIFICATION";
export const resendVerification = createAction(RESEND_VERIFICATION);
